import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { API_URLS, KEYS } from '../global';
import { ProgressBarService } from './progress-bar.service';
import { StateService } from './state.service';
import { UtilsService } from './utils.service';

@Injectable({
  providedIn: 'root'
})
export class GeolocationService {
  BingKey: string = '';

  constructor(
    private readonly http: HttpClient,
    private readonly utils: UtilsService,
    private readonly stateService: StateService,
  ) {
    this.stateService.renderingDataSubject.subscribe(renderingData => {
      this.BingKey = renderingData?.LocationSettings?.BingKey || '';
    });
   }


  getCurrentPosition(): Observable<GeolocationPosition> {
    return new Observable(observer => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(position => {
          observer.next(position);
        }, error => observer.error(error.message),
          { enableHighAccuracy: true, timeout: 10 * 1000, maximumAge: 0 });
      } else {
        observer.error('Geolocation is not supported');
      }
    });
  }

  getZipcodeByCoordinates(latitude: number, longitude: number): Observable<any> {
    return new Observable(observer => {
      const url = `${window.location.protocol}${API_URLS.BING}${latitude},${longitude}?includeEntityTypes=Postcode1&o=json&key=${this.BingKey}&jsonp=JSONP_CALLBACK`;
      this.http.jsonp(url, "JSONP_CALLBACK").subscribe((response: any) => {
        console.log('@@@ Bing Maps response: ', response);
        observer.next(this.utils.extractValueFromObject(response, 'resourceSets[0].resources[0].address.postalCode'));
      }, error => observer.error(error));
    });
  }

  getZipcode(): Observable<any> {
    return new Observable(observer => {
      const handleError = (errorMessage: string) => {
        console.log(errorMessage);
        observer.error(errorMessage);
      };

      this.getCurrentPosition().subscribe(position => {
        this.getZipcodeByCoordinates(position.coords.latitude, position.coords.longitude).subscribe(value => {
          if (value) console.log('@@@ Getting zipcode: ' + value + ' with accuracy: ' + position.coords.accuracy + ' meters.');
          observer.next(value);
        }, error => {
          handleError(error);
        })
      }, error => {
        handleError(error);
      });
    });
  }

}
